<template>
  <div class="downloadDetail">
    <div class="poster">
      <img src="../../assets/images/poster/gongcyj.png" alt="">
    </div>

    <div class="title" @click="$router.back(-1)">
      返回
      <mis-icon icon="back" font-size="18px"></mis-icon>
    </div>

    <div class="proInfo" v-if="detailInfo.id">
      <div class="classInfo">
        <p>
          <span>标题：</span>
          <span>{{ detailInfo.title }}</span>
        </p>

        <p>
          <span>发布时间：</span>
          <span>{{ detailInfo.time }}</span>
        </p>

        <el-button
          size="mini"
          @click="download"
          v-if="detailInfo.img"
        >
          下载附件
        </el-button>
      </div>

      <div class="attachment-preview" v-if="detailInfo.img">
        <!-- 图片格式直接展示 -->
        <div v-if="isImage" class="preview-image">
          <img :src="baseUrl + detailInfo.img" alt="附件图片">
        </div>
        <!-- PDF格式内嵌展示 -->
        <div v-else-if="isPdf" class="preview-pdf">
          <iframe :src="baseUrl + detailInfo.img" width="100%" height="600px" frameborder="0"></iframe>
        </div>
        <!-- 其他格式提示下载 -->
        <div v-else class="preview-other">
          <p>该附件格式不支持在线预览，请下载后查看</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUp } from "@/api/up";

export default {
  name: "downloadDetail",

  data() {
    const baseUrl = process.env.VUE_APP_BASE_API

    return {
      baseUrl: baseUrl,
      id: this.$route.query.id || '',
      detailInfo: {}
    }
  },

  computed: {
    isImage() {
      if (!this.detailInfo.img) return false
      const ext = this.detailInfo.img.toLowerCase().split('.').pop()
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)
    },
    isPdf() {
      if (!this.detailInfo.img) return false
      const ext = this.detailInfo.img.toLowerCase().split('.').pop()
      return ext === 'pdf'
    }
  },

  created() {
    if (this.id) {
      this.getDetailInfo()
    }
  },

  methods: {
    getDetailInfo() {
      getUp(this.id).then(res => {
        console.log('详情', res)
        this.detailInfo = res.data
      }).catch(err => {
        console.error('获取详情失败', err)
      })
    },

    download() {
      window.open(this.baseUrl + this.detailInfo.img)
    }
  }
}
</script>

<style scoped lang="less">
.downloadDetail {
  .poster {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .title {
    border-bottom: 1px solid #dcdfe6;
    text-align: right;
    padding: 10px 10px 10px 0;
    color: #0d6fb8;

    &:hover {
      cursor: pointer;
      color: #409eff;
    }
  }

  .proInfo {
    margin-top: 20px;
    display: flex;
    flex-direction: column;

    .classInfo {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 15px;
      background: #f5f7fa;
      border-radius: 8px;
      margin-bottom: 20px;

      p {
        margin: 5px 20px 5px 0;
        font-size: 14px;
        color: #303133;

        span:first-child {
          color: #909399;
        }
      }
    }
  }

  .attachment-preview {
    width: 100%;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
    background: #fff;

    .preview-image {
      text-align: center;

      img {
        max-width: 100%;
        max-height: 800px;
        border-radius: 4px;
      }
    }

    .preview-pdf {
      iframe {
        border-radius: 4px;
        border: 1px solid #ebeef5;
      }
    }

    .preview-other {
      text-align: center;
      padding: 40px 0;
      color: #909399;
      font-size: 14px;
    }
  }

  @media screen and (min-width: 768px) {
    .proInfo {
      max-width: 1170px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media screen and (max-width: 768px) {
    .attachment-preview {
      padding: 10px;
    }

    .preview-pdf iframe {
      height: 400px;
    }
  }
}
</style>
